//* fetch all data from a specific table
export const fetchDataList = async (table) => {
  return fetch(`${process.env.REACT_APP_API_URL}/${table}`, {
    credentials: "include",
  }).then((res) => res.json());
};

//* fetch data from specific table row
export const fetchData = async (table, id) => {
  return fetch(`${process.env.REACT_APP_API_URL}/${table}/${id}`, {
    credentials: "include",
  }).then((res) => res.json());
};

//* fetch data from specific table category
export const fetchCategoryData = async (table, category, id) => {
  return fetch(`${process.env.REACT_APP_API_URL}/${table}/${category}/${id}`, {
    credentials: "include",
  }).then((res) => res.json());
};

//* fetch limited data from specific table
export const fetchFilterData = async (table, page, length) => {
  return fetch(
    `${process.env.REACT_APP_API_URL}/${table}?offset=${
      page * length
    }&length=${length}`,
    {
      credentials: "include",
    },
  ).then((res) => res.json());
};

//* fetch limited data from specific company
export const fetchCompanyDataList = async (table, id, page, length) => {
  return fetch(
    `${process.env.REACT_APP_API_URL}/${table}/${id}?offset=${
      page * length
    }&length=${length}`,
    {
      credentials: "include",
    },
  ).then((res) => res.json());
};

//* fetch limited data from specific category
export const fetchSubjectData = async (table, id, page, length) => {
  return fetch(
    `${process.env.REACT_APP_API_URL}/${table}/${id}?offset=${
      page * length
    }&length=${length}`,
    {
      credentials: "include",
    },
  ).then((res) => res.json());
};

//* fetch data length from specific category
export const fetchSubjectLength = async (table, id) => {
  return fetch(`${process.env.REACT_APP_API_URL}/${table}?category=${id}`, {
    credentials: "include",
  }).then((res) => res.json());
};

//* fetch limited data from matching elements of search
export const fetchSearchData = async (table, value, page, length) => {
  return fetch(
    `${process.env.REACT_APP_API_URL}/${table}?value=${value}&offset=${
      page * length
    }&length=${length}`,
    {
      credentials: "include",
    },
  ).then((res) => res.json());
};

//* fetch data length from matching elements of search
export const fetchSearchLength = async (table, value) => {
  return fetch(`${process.env.REACT_APP_API_URL}/${table}?search=${value}`, {
    credentials: "include",
  }).then((res) => res.json());
};

//* send email
export const sendEmail = async (email, subject, message) => {
  const response = await fetch(`${process.env.REACT_APP_API_URL}/email/send`, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      email,
      subject,
      message,
    }),
  });

  if (!response.ok) {
    throw new Error("Error while sending email");
  }

  return response.json();
};

//* fetch data length from table
export const fetchDataLength = async (table) => {
  return fetch(`${process.env.REACT_APP_API_URL}/${table}`, {
    credentials: "include",
  }).then((res) => res.json());
};

//* fetch limited data from table
export const fetchLimitedData = async (table, page, length) => {
  return fetch(
    `${process.env.REACT_APP_API_URL}/${table}?offset=${
      page * length
    }&length=${length}`,
    {
      credentials: "include",
    },
  ).then((res) => res.json());
};

//* calculate compound interest
export const calculateCompoundInterest = async (
  capital,
  saving,
  interest,
  duration,
  interval,
) => {
  return fetch(
    `${process.env.REACT_APP_API_URL}/calculation/compoundinterest?capital=${capital}&saving=${saving}&interest=${interest}&duration=${duration}&interval=${interval}`,
    {
      credentials: "include",
    },
  ).then((res) => res.json());
};

//* calculate cashflow
export const calculateCashflow = async (params) => {
  return fetch(
    `${process.env.REACT_APP_API_URL}/calculation/cashflow?parameters=${params}`,
    {
      credentials: "include",
    },
  ).then((res) => res.json());
};

//* calculate roi
export const calculateROI = async (
  investment,
  amount,
  percentage,
  dividendYield,
  increaseDividend,
) => {
  return fetch(
    `${process.env.REACT_APP_API_URL}/calculation/roi?investment=${investment}&amount=${amount}&increasePercentage=${percentage}&dividendYield=${dividendYield}&increaseDividend=${increaseDividend}`,
    {
      credentials: "include",
    },
  ).then((res) => res.json());
};

//* calculate inflation
export const calculateInflation = async (amount, inflationRate, duration) => {
  return fetch(
    `${process.env.REACT_APP_API_URL}/calculation/inflation?amount=${amount}&inflation=${inflationRate}&duration=${duration}`,
    {
      credentials: "include",
    },
  ).then((res) => res.json());
};

//* user login
export const login = async (user, password) => {
  const response = await fetch(`${process.env.REACT_APP_API_URL}/auth/login`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ user, password }),
    credentials: "include",
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error?.message || "Login fehlgeschlagen");
  }

  const data = await response.json();
  return data; // oder data.jwt, je nachdem wie dein Backend antwortet
};

export const twofactor = async (user, code) => {
  const response = await fetch(
    `${process.env.REACT_APP_API_URL}/auth/twofactor`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ user, code }),
      credentials: "include",
    },
  );

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error?.message || "Login fehlgeschlagen");
  }

  const data = await response.json();
  return data; // oder data.jwt, je nachdem wie dein Backend antwortet
};

//* check login status
export const checkLogin = async () => {
  return fetch(`${process.env.REACT_APP_API_URL}/auth/me`, {
    credentials: "include",
  }).then((res) => res.json());
};

//* get current user
export const getCurrentUser = async () => {
  return fetch(`${process.env.REACT_APP_API_URL}/auth/currentuser`, {
    credentials: "include",
  }).then((res) => res.json());
};

//* change user password
export const changePassword = async (oldPassword, newPassword) => {
  const res = await fetch(`${process.env.REACT_APP_API_URL}/auth/password`, {
    method: "PUT",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      oldCredentials: oldPassword,
      newCredentials: newPassword,
    }),
  });

  const data = await res.json();

  if (!res.ok) {
    throw new Error(data.message || "Passwort konnte nicht geändert werden.");
  }

  return data;
};

//* user logout
export const logout = async () => {
  const response = await fetch(`${process.env.REACT_APP_API_URL}/auth/logout`, {
    method: "POST",
    credentials: "include",
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error?.message || "Logout fehlgeschlagen");
  }

  const data = await response.json();
  return data;
};

//* fetch current user data
export const loadUser = async () => {
  return fetch(`${process.env.REACT_APP_API_URL}/userprofile`, {
    credentials: "include",
  }).then((res) => res.json());
};
//* fetch user dividends
export const fetchDividend = async (page, length) => {
  return fetch(
    `${process.env.REACT_APP_API_URL}/mydividend?offset=${
      page * length
    }&length=${length}`,
    {
      credentials: "include",
    },
  ).then((res) => res.json());
};

//* fetch total dividend sum
export const fetchTotalDividendSum = async () => {
  return fetch(`${process.env.REACT_APP_API_URL}/mytotaldividend`, {
    credentials: "include",
  }).then((res) => res.json());
};

//* add new dividend payment
export const addNewDividend = async (ticker, date, value) => {
  const response = await fetch(
    `${process.env.REACT_APP_API_URL}/addNewDividend`,
    {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ ticker, date, value }),
    },
  );

  if (!response.ok) {
    const error = await response.json();
    throw new Error(
      error.message || "Dividende konnte nicht hinzugefügt werden",
    );
  }

  return await response.json(); // z. B. { success: true, message: 'Dividende hinzugefügt' }
};

//* update trade
export const updateDividend = async (ticker, oldDate, date, value) => {
  const response = await fetch(
    `${process.env.REACT_APP_API_URL}/updateDividend`,
    {
      method: "PATCH",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ ticker, oldDate, date, value }),
    },
  );

  if (!response.ok) {
    const error = await response.json();
    throw new Error(
      error.message || "Dividende konnte nicht aktualisiert werden",
    );
  }

  return await response.json();
};

//* delete dividend
export const deleteDividend = async (ticker, date) => {
  const response = await fetch(
    `${process.env.REACT_APP_API_URL}/deleteDividend`,
    {
      method: "DELETE",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ ticker, date }),
    },
  );

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || "Dividende konnte nicht gelöscht werden");
  }

  return await response.json();
};

//* fetch user trades
export const fetchTrades = async (page, length) => {
  return fetch(
    `${process.env.REACT_APP_API_URL}/mytrades?offset=${
      page * length
    }&length=${length}`,
    {
      credentials: "include",
    },
  ).then((res) => res.json());
};

//* fetch total trade sum
export const fetchTotalTradeSum = async () => {
  return fetch(`${process.env.REACT_APP_API_URL}/mytotaltrades`, {
    credentials: "include",
  }).then((res) => res.json());
};

//* add new trade
export const addNewTrade = async (
  type,
  ticker,
  date,
  investment,
  share,
  hint,
) => {
  const response = await fetch(`${process.env.REACT_APP_API_URL}/addNewTrade`, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ type, ticker, date, investment, share, hint }),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || "Trade konnte nicht hinzugefügt werden");
  }

  return await response.json();
};

//* update trade
export const updateTrade = async (
  type,
  ticker,
  oldDate,
  date,
  investment,
  share,
  hint,
) => {
  const response = await fetch(`${process.env.REACT_APP_API_URL}/updateTrade`, {
    method: "PATCH",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      type,
      ticker,
      oldDate,
      date,
      investment,
      share,
      hint,
    }),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || "Trade konnte nicht aktualisiert werden");
  }

  return await response.json();
};

//* delete trade
export const deleteTrade = async (ticker, date) => {
  const response = await fetch(`${process.env.REACT_APP_API_URL}/deleteTrade`, {
    method: "DELETE",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ ticker, date }),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || "Trade konnte nicht gelöscht werden");
  }

  return await response.json();
};

//* fetch user portfolio
export const fetchPortfolio = async (page, length) => {
  return fetch(
    `${process.env.REACT_APP_API_URL}/myportfolio?offset=${
      page * length
    }&length=${length}`,
    {
      credentials: "include",
    },
  ).then((res) => res.json());
};

//* fetch user portfolio charts
export const fetchPortfolioCharts = async () => {
  return fetch(`${process.env.REACT_APP_API_URL}/myportfoliocharts`, {
    credentials: "include",
  }).then((res) => res.json());
};

//* fetch user family analysis
export const fetchFamilyAnalysis = async () => {
  return fetch(`${process.env.REACT_APP_API_URL}/myfamilyanalysis`, {
    credentials: "include",
  }).then((res) => res.json());
};

//* fetch all companies
export const fetchAllCompany = async () => {
  return fetch(`${process.env.REACT_APP_API_URL}/company/all`, {
    credentials: "include",
  }).then((res) => res.json());
};

//* fetch all crypto
export const fetchAllCrypto = async () => {
  return fetch(`${process.env.REACT_APP_API_URL}/crypto/all`, {
    credentials: "include",
  }).then((res) => res.json());
};

//* fetch all assets
export const fetchAllAssets = async () => {
  return fetch(`${process.env.REACT_APP_API_URL}/assets/all`, {
    credentials: "include",
  }).then((res) => res.json());
};

//* update asset
export const updateAsset = async (ticker, value) => {
  const response = await fetch(`${process.env.REACT_APP_API_URL}/updateAsset`, {
    method: "PATCH",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ ticker, value }),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || "Asset konnte nicht aktualisiert werden");
  }

  return await response.json();
};

//* fetch userspecific company data
export const fetchCompanyInvestment = async (ticker) => {
  return fetch(`${process.env.REACT_APP_API_URL}/mycompanydata/${ticker}`, {
    credentials: "include",
  }).then((res) => res.json());
};

//#region property
//* fetch user properties
export const fetchProperties = async (page, length) => {
  return fetch(
    `${process.env.REACT_APP_API_URL}/properties?offset=${
      page * length
    }&length=${length}`,
    {
      credentials: "include",
    },
  ).then((res) => res.json());
};

//* fetch specific user property
export const fetchProperty = async (zip, id) => {
  return fetch(`${process.env.REACT_APP_API_URL}/property/${zip}/${id}`, {
    credentials: "include",
  }).then((res) => res.json());
};

//* fetch specific user property finance data
export const fetchPropertyFinance = async (id) => {
  return fetch(`${process.env.REACT_APP_API_URL}/property-finance/${id}`, {
    credentials: "include",
  }).then((res) => res.json());
};

//* add new property rate
export const addNewRate = async (propertyID, lender, type, date, amount) => {
  const response = await fetch(
    `${process.env.REACT_APP_API_URL}/property-rate-new`,
    {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ propertyID, lender, type, date, amount }),
    },
  );

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || "Daten konnten nicht hinzugefügt werden");
  }

  return await response.json();
};

//* update mortage rate
export const updateMortageRate = async (
  propertyId,
  creditId,
  paymentId,
  date,
  type,
  value,
) => {
  const response = await fetch(
    `${process.env.REACT_APP_API_URL}/property-rate-update`,
    {
      method: "PATCH",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        propertyId,
        creditId,
        paymentId,
        date,
        type,
        value,
      }),
    },
  );

  if (!response.ok) {
    const error = await response.json();
    throw new Error(
      error.message || "Zahlung konnte nicht aktualisiert werden",
    );
  }

  return await response.json();
};

//* delete mortage rate
export const deleteMortageRate = async (propertyId, creditId, paymentId) => {
  const response = await fetch(
    `${process.env.REACT_APP_API_URL}/property-rate-delete`,
    {
      method: "DELETE",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ propertyId, creditId, paymentId }),
    },
  );

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || "Zahlung konnte nicht gelöscht werden");
  }

  return await response.json();
};

//* fetch specific user property finance data
export const fetchPropertyExpense = async (id) => {
  return fetch(`${process.env.REACT_APP_API_URL}/property-expenses/${id}`, {
    credentials: "include",
  }).then((res) => res.json());
};

//* add new expense
export const addNewExpense = async (
  propertyID,
  company,
  date,
  reason,
  reference,
  value,
) => {
  const response = await fetch(
    `${process.env.REACT_APP_API_URL}/property-expense-new`,
    {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        propertyID,
        company,
        date,
        reason,
        reference,
        value,
      }),
    },
  );

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || "Daten konnten nicht hinzugefügt werden");
  }

  return await response.json();
};

//* update expense
export const updateExpense = async (
  propertyId,
  expenseId,
  company,
  date,
  reason,
  reference,
  value,
) => {
  const response = await fetch(
    `${process.env.REACT_APP_API_URL}/property-expense-update`,
    {
      method: "PATCH",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        propertyId,
        expenseId,
        company,
        date,
        reason,
        reference,
        value,
      }),
    },
  );

  if (!response.ok) {
    const error = await response.json();
    throw new Error(
      error.message || "Ausgabe konnte nicht aktualisiert werden",
    );
  }

  return await response.json();
};

//* delete expense
export const deleteExpense = async (propertyId, expenseId) => {
  const response = await fetch(
    `${process.env.REACT_APP_API_URL}/property-expense-delete`,
    {
      method: "DELETE",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ propertyId, expenseId }),
    },
  );

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || "Zahlung konnte nicht gelöscht werden");
  }

  return await response.json();
};

//#endregion

//#region family
export const fetchFamilyBudget = async () => {
  return fetch(`${process.env.REACT_APP_API_URL}/familybudget`, {
    credentials: "include",
  }).then((res) => res.json());
};

//* fetch family bookings
export const fetchFamilyBooking = async (page, length) => {
  return fetch(
    `${process.env.REACT_APP_API_URL}/familybookings?offset=${
      page * length
    }&length=${length}`,
    {
      credentials: "include",
    },
  ).then((res) => res.json());
};
//#endregion

//* fetch user nfts
export const fetchNfts = async (page, length) => {
  return fetch(
    `${process.env.REACT_APP_API_URL}/mynft?offset=${
      page * length
    }&length=${length}`,
    {
      credentials: "include",
    },
  ).then((res) => res.json());
};

//* fetch specific user nft
export const fetchNft = async (chain, contract, id) => {
  return fetch(
    `${process.env.REACT_APP_API_URL}/nft/${chain}/${contract}/${id}`,
    {
      credentials: "include",
    },
  ).then((res) => res.json());
};

//* add new nft
export const addNewNFT = async (chain, contract, id, date) => {
  const response = await fetch(`${process.env.REACT_APP_API_URL}/addNewNft`, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ chain, contract, id, date }),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || "NFT konnte nicht hinzugefügt werden");
  }

  return await response.json();
};

//* update nft
export const updateNFT = async (oldChain, oldContract, oldId, date) => {
  const response = await fetch(`${process.env.REACT_APP_API_URL}/updateNft`, {
    method: "PATCH",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      oldChain,
      oldContract,
      oldId,
      date,
    }),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || "NFT konnte nicht aktualisiert werden");
  }

  return await response.json();
};

//* delete nft
export const deleteNFT = async (chain, contract, id) => {
  const response = await fetch(`${process.env.REACT_APP_API_URL}/deleteNft`, {
    method: "DELETE",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ chain, contract, id }),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || "NFT konnte nicht gelöscht werden");
  }

  return await response.json();
};

export const supportedChains = async () => {
  return fetch(`${process.env.REACT_APP_API_URL}/chains`, {
    credentials: "include",
  }).then((res) => res.json());
};

export const getUserCashflow = async () => {
  return fetch(`${process.env.REACT_APP_API_URL}/usercashflow`, {
    credentials: "include",
  }).then((res) => res.json());
};

export const chatWithLlm = async (messages) => {
  const response = await fetch(`${process.env.REACT_APP_API_URL}/llm/chat`, {
    method: "POST",
    credentials: "include", // 🔐 wichtig für JWT Cookie!
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      messages,
    }),
  });

  if (!response.ok) {
    throw new Error("Error while calling LLM");
  }

  return response.json();
};
